'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/BusinessUnits';
const INIT_STATE = {
  businessUnits: [],
  requestState: RequestState.NOT_REQUESTED
};
export function businessUnits(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_BUSINESS_UNITS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_BUSINESS_UNITS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_BUSINESS_UNITS:
      return Object.assign({}, state, {
        businessUnits: action.businessUnits
      });
    case Actions.FAILED_GETTING_BUSINESS_UNITS:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
}